export const LESSON_STATUS = {
  DONE: 'realizada',
  NEXT: 'proxima',
  PLANNED: 'prevista'
};

export const LESSON_STATUS_LABEL = {
  [LESSON_STATUS.DONE]: 'Realizada',
  [LESSON_STATUS.NEXT]: 'Próxima aula',
  [LESSON_STATUS.PLANNED]: 'Prevista'
};

export const QUARTER_LABEL = {
  Q1: '1º trimestre',
  Q2: '2º trimestre',
  Q3: '3º trimestre',
  Q4: '4º trimestre'
};
